module.exports = __webpack_public_path__ + "img/ebf7081.svg";